import { proposedGet } from '@/api/proposedEndpoint'
import { shareUnlocksSchema, type ShareUnlock } from '@/schemas/share-unlocks'

/**
 * THE switch for the rail's "Shares unlocking soon". mm-be carries no lock-in data yet, so this is
 * `false`: no request is made, no query is built, and the block draws its real head over the
 * generic "Not available yet" state. Flip it to `true` when the endpoint ships (`asks/rail.md`).
 */
export const SHARE_UNLOCKS_AVAILABLE: boolean = false

/** The proposed path. Upcoming unlocks, soonest first, public. */
const PATH = '/api/v5/market/share-unlocks/'

/** The rail draws four rows. */
export const SHARE_UNLOCKS_LIMIT = 4

/** One row as the proposed endpoint sends it. `quantity` is a count of kitta, not a decimal. */
interface WireShareUnlock {
  symbol: string
  name: string
  unlock_date: string
  quantity: number
  holder: string
}

export const shareUnlocksService = {
  upcoming: async (): Promise<ShareUnlock[]> => {
    const rows = await proposedGet<WireShareUnlock[]>(PATH, { limit: SHARE_UNLOCKS_LIMIT })
    return shareUnlocksSchema.parse(
      rows.map((row) => ({
        symbol: row.symbol,
        name: row.name,
        unlockDate: row.unlock_date,
        quantity: row.quantity,
        holder: row.holder,
      })),
    )
  },
}
